export default __webpack_public_path__ + "static/media/astaradai_pfp.b5ac7cbf.png";